<div class="list-group-item-action form-list-row">
  <div style="display: flex; flex-direction: row; align-items: center; gap: 20px">
    <img src="../../../assets/pdf_icon.svg" alt="" height="75" width="75">
    <div style="display: flex; flex-direction: column; gap: 5px; flex-grow: 1">
      <ng-content></ng-content>
    </div>
  </div>
</div>
